import React from 'react';
import cx from 'classnames';

import Card from '@marketing/components/card';

import styles from './style.module.scss';

interface Props {
  valueProps: {
    description: string;
    icon: string;
    name: string;
  }[];
}

export default (props: Props) => {
  const firstRowValueProps = props.valueProps.slice(0, 3);
  const secondRowValueProps = props.valueProps.slice(3);

  return (
    <div className="d-flex flex-1 flex-column gap-s gap-lg-m">
      <div
        className={cx(
          styles.valuePropCardsContainer,
          'align-items-center d-flex flex-1 flex-column flex-lg-row gap-s gap-lg-m'
        )}
      >
        {
          firstRowValueProps.map((valueProp, idx) => (
            <Card className={cx(styles.valuePropCard, 'd-flex flex-1 flex-column gap-m')} skewAngle={idx % 2 === 0 ? -1 : 1}>
              <div className="align-items-center d-flex gap-xs">
                <div>
                  <img
                    alt=""
                    height="24px"
                    src={valueProp.icon}
                    width="24px"
                  />
                </div>

                <div className="text-uppercase">
                  <strong>{valueProp.name}</strong>
                </div>
              </div>

              <div style={{ fontSize: 15 }}>
                {valueProp.description}
              </div>
            </Card>
          ))
        }
      </div>

      <div
        className={cx(
          styles.valuePropCardsContainer,
          'align-items-center d-flex flex-1 flex-column flex-lg-row gap-s gap-lg-m justify-content-lg-end'
        )}
      >
        {
          secondRowValueProps.map((valueProp, idx) => (
            <Card className={cx(styles.valuePropCard, 'd-flex flex-column gap-m')} skewAngle={idx % 2 === 0 ? -1 : 1}>
              <div className="align-items-center d-flex gap-xs">
                <div>
                  <img
                    alt=""
                    height="24px"
                    src={valueProp.icon}
                    width="24px"
                  />
                </div>

                <div className="text-uppercase">
                  <strong>{valueProp.name}</strong>
                </div>
              </div>

              <div style={{ fontSize: 15 }}>
                {valueProp.description}
              </div>
            </Card>
          ))
        }
      </div>
    </div>
  );
};
